import styled from 'styled-components';

export const ContanctUs = styled.div`
    .form-and-info {
        margin:40px 0px;
    }
`